module.exports = __webpack_public_path__ + "assets/media/day24.db340cc4.mp3";